export default __webpack_public_path__ + "static/media/health.39a425a6.yaml";